import createReactComponent from '../createReactComponent';
export default createReactComponent('scissors', 'IconScissors', [
  ['path', { d: 'M6 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-0' }],
  ['path', { d: 'M6 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-1' }],
  ['path', { d: 'M8.6 8.6l10.4 10.4', key: 'svg-2' }],
  ['path', { d: 'M8.6 15.4l10.4 -10.4', key: 'svg-3' }],
]);
